module.exports = __webpack_public_path__ + "8a2781a0b6bb5f04bf2bacdcf890dd33.svg";